<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">通知信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div class style="width:500px">
        <SForm
          ref="formref"
          :url="formurl"
          method="put"
          :fields="formfields"
          :data-form="rowdata"
          :before="formbefore"
          label-width="120px"
          :is-show-btn="false"
          label-position="right"
          :inline="false"
        />
      </div>
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="">
            <GoodStreeDetail v-model="form.noticeUser" v-if="rowdata.noticeObject == '按归属企业选择用户'"  :data="userTree" style="width:400px;" />
          <!-- <StreeNew v-if="rowdata.noticeObject == '按归属企业选择用户'" v-model="form.noticeUser" :data="userTree" checked-type="user" style="width:100%;margin-top:-15px" :is-show-filter="false" /> -->
          <!-- <el-tree v-if="rowdata.noticeObject == '全平台用户'" :data="userTree" :props="defaultProps" style="width:100%;margin-top:-15px" /> -->
          <GoodStreeDetail  v-if="rowdata.noticeObject == '全平台用户'" :data="userTree" style="width:100%;margin-top:-15px" />
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { treeDisabled } from '@/utils/tool'
export default {
  name: 'Xiaoxixiangqing',
  components: {},
  data() {
    return {
      formurl: '',
      rowdata: {},
      checkedArr:[],
      form: {
        noticeUser: []
      },
      userTree: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      formfields: [
        {
          label: '通知标题',
          type: 'div',
          style: 'width:100%',
          prop: 'noticeName'
        },
        {
          label: '通知内容',
          type: 'div',
          style: 'width:100%',
          prop: 'noticeContext'
        },
        {
          label: '发送时间',
          type: 'div',
          style: 'width:100%',
          prop: 'sendTime'
        },
        {
          label: '发送方式',
          type: 'div',
          style: 'width:100%',
          prop: 'sendMode'
        },
        {
          label: '发送对象',
          type: 'div',
          style: 'width:100%',
          prop: 'noticeObject'
        }
        // {
        //     label: "发送用户",
        //     type: "unTree",
        //     option: {
        //         data: [],
        //     },
        //     prop: "noticeObject",
        //     defaultProps: {
        //         children: 'children',
        //         label: 'name',
        //     },
        // },
      ],
      formbefore: record => {
        console.log(record)
        return record
      },
      id: ''

    }
  },
  computed: {

  },
  mounted() {
    this.getDetail()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
    this.getTree()
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    },

    getDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/business/notify/detail',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp.noticeObject === 0) {
            resp.noticeObject = '全平台用户'
          } else if (resp.noticeObject === 1) {
            resp.noticeObject = '按归属企业选择用户'
            this.form.noticeUser = resp.noticeUser ? resp.noticeUser.split(',') : []
             this.checkedArr= this.form.noticeUser
          }

          if (resp.sendMode === '0') {
            resp.sendMode = 'APP推送'
          } else if (resp.sendMode === '1') {
            resp.sendMode = '短信推送'
          } else if (resp.sendMode === '2') {
            resp.sendMode = 'APP推送+短信推送'
          }
          this.rowdata = resp
        }
      })
    },

    getTree() {
      this.$store.dispatch('form/handle', {
        url: '/business/notify/getOrgAndUser',
        method: 'get',
        callback: resp => {
          this.userTree = treeDisabled(resp, true)
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
 }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/informManagement/informDetail.vue